const validateHourInput = (inputValue) => {
  if (inputValue === '') {
    return '';
  }

  if (!/^\d{0,2}$/.test(inputValue)) {
    return null;
  }

  const numValue = Number(inputValue);
  if (numValue >= 1 && numValue <= 24) {
    return inputValue;
  }

  return null;
};

export default validateHourInput;
